import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { ScrollView } from "react-native-gesture-handler";
import React from 'react';
import Footer from '../../components/basic/Footer';
import OSL from '../../assets/licenses.json';
import {useSafeAreaInsets} from "react-native-safe-area-context";

export default function OpenSourceLicense({navigation, hideFooter}) {
    const insets = useSafeAreaInsets()

    return (
        <VStack space='xs' className="flex-1 bg-secondary-50">
            <ScrollView scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 70 + insets.bottom }} className="flex-1 bg-secondary-50 py-3 px-3">
                <VStack space='sm' className="flex-1">
                    <Text className="text-black leading-xs">
                        Copyright 2022 BOS Connect GmbH
                        {'\n\n'}
                        Permission is hereby granted, free of charge, to any person obtaining a copy of this software
                        and associated documentation files (the "Software"), to deal in the Software without
                        restriction, including without limitation the rights to use, copy, modify, merge, publish,
                        distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the
                        Software is furnished to do so, subject to the following conditions:
                        {'\n\n'}
                        The above copyright notice and this permission notice shall be included in all copies or
                        substantial portions of the Software.
                        {'\n\n'}
                        THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
                        BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                        NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                        DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                        OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                    </Text>
                    {OSL.map(license => (
                            <Text key={license.name + license.index} className="text-black font-[400] leading-xs">
                                Name: {license.name + '\n'}
                                Author: {license.author + '\n'}
                                Link: {license.link + '\n'}
                                License Type: {license.licenseType + '\n'}
                                Installed Version: {license.installedVersion + '\n'}
                                License Period: {license.licensePeriod + '\n'}
                            </Text>
                        )
                    )}
                    <Text>{'\n'}</Text>
                </VStack>
            </ScrollView>
            {!hideFooter && <Footer navigation={navigation}/>}
        </VStack>
    );
}
